import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import {
  AuthState,
  initialAuthState,
} from '@literax/modules/auth/store/auth.state';
import {
  ConfigState,
  initialConfigState,
} from '@literax/modules/configurations/store/config/config.state';
import {
  IApiConfigurationsInterface,
  initialApiConfigurationsState,
} from '@literax/components/configurations/api/config/store/api.state';
import {
  IAppearanceConfigurationsInterface,
  initialAppearanceConfigurationsState,
} from '../components/configurations/appearance/config/store/appearance.state';
import {
  IApproverRequestWorkspaceState,
  initialApproverRequestWorkspaceState,
} from './approve-request/approve-request.state';
import {
  IAttachmentState,
  initialAttachmentState,
} from '../modules/documents/store/attachment/attachment.state';
import {
  IBackButtonState,
  initialBackButtonState,
} from './back-button/back-button.state';
import {
  ICLientUsersState,
  initialClientUserState,
} from '@literax/components/configurations/users/states/users.state';
import {
  ICatalogState,
  initialCatalogState,
} from '../modules/documents/store/catalog/catalog.state';
import {
  IClientState,
  initialClientState,
} from '../modules/configurations/store/client/client.state';
import {
  ICompanyState,
  initialCompanyState,
} from '@literax/modules/configurations/store/company/company.state';
import { ICoreState, initialAplicationState } from './core/core.state';
import {
  IDashboardState,
  initialDashboardState,
} from './dashboard/dashboard.state';
import {
  IDepartmentState,
  initialDepartmentState,
} from '@literax/modules/configurations/store/department/department.state';
import {
  IDocumentState,
  initialDocumentState,
} from '../modules/documents/store/document/document.state';
import {
  IFreeDocumentState,
  initialFreeDocumentState,
} from './free-document/free-document.state';
import {
  IFreeSignatureState,
  initialFreeSignatureState,
} from './free-signature/free-signature.state';
import {
  IFreeTermsState,
  initialFreeTermsState,
} from './free-terms/free-terms.state';
import {
  IProfilesState,
  initiaProfileslState,
  profileReducer,
} from '@literax/components/configurations/profiles/states/profiles.reducer';
import {
  IPromissoryNoteReportState,
  initialPromissoryNoteReportState,
} from './report/report-promissory-note.state';
import {
  IPromissoryNotesState,
  initialPromissoryNotesState,
} from '@literax/modules/promissory-notes/store/promissory-notes.state';
import {
  IRegistrationState,
  initialRegistrationState,
} from './registration/registration.state';
import {
  IReportState,
  initialReportState,
} from '@literax/store/report/report.state';
import {
  IReviewRequestWorkspaceState,
  initialReviewRequestWorkspaceState,
} from './review-request/review-request.state';
import { IRolState, initialRolState } from './rol/rol.state';
import {
  ISignRequestState,
  initialSignRequestState,
} from '../modules/documents/store/sign-request/sign-request.state';
import {
  ISignatureState,
  initialSignatureState,
} from '@literax/modules/documents/store/signature/signature.state';
import { IStatusState, initialStatusState } from './status/status.state';
import {
  ITemplatesFieldsState,
  initialTemplatesFieldsState,
} from '@literax/store/template-fields/templates-fields.state';
import {
  ITemplatesState,
  initialTemplatesState,
} from '@literax/modules/templates/store/templates.state';
import { ITermsState, initialTermsState } from './terms/terms.state';
import {
  ITitleNavbarState,
  initialTitleNavbarState,
} from './title-navbar/title-navbar.state';
import {
  ITokenRSAConfigurations,
  initialTokenRSAConfigurationsState,
} from '../components/configurations/token-rsa/config/store/token-rsa.state';
import {
  IUserProfiles,
  initiaUserProfileslState,
} from '@literax/components/platform/profiles/store/user-profiles.state';
import {
  IValidatorState,
  initialValidatorState,
} from '@literax/modules/validator/store/validator.state';
import {
  ISuretyValidatorState,
  initialSuretyValidatorState,
} from '@literax/modules/surety-validator/store/surety-validator.state';
import { RouterReducerState, routerReducer } from '@ngrx/router-store';
import {
  WorkspaceState,
  initialWorkspaceState,
} from '@literax/modules/documents/store/workspace/workspace.state';

import { apiConfigurationsReducer } from '@literax/components/configurations/api/config/store/api.reducers';
import { appearanceConfigurationsReducer } from '../components/configurations/appearance/config/store/appearance.reducers';
import { approversReducer } from './approve-request/approve-request.reducer';
import { attachmentReducers } from '../modules/documents/store/attachment/attachment.reducers';
import { authReducers } from '@literax/modules/auth/store/auth.reducers';
import { backButtonReducer } from './back-button/back-button.reducer';
import { catalogReducers } from '@literax/modules/documents/store/catalog/catalog.reducers';
import { clientReducers } from '../modules/configurations/store/client/client.reducers';
import { clientUserReducer } from '@literax/components/configurations/users/states/users.reducer';
import { companyReducers } from '@literax/modules/configurations/store/company/company.reducers';
import { configReducers } from '@literax/modules/configurations/store/config/config.reducers';
import { coreReducers } from './core/core.reducers';
import { dashboardReducers } from './dashboard/dashboard.reducers';
import { departmentReducers } from '@literax/modules/configurations/store/department/department.reducers';
import { environment } from '../../environments/environment';
import { freeDocumentReducers } from './free-document/free-document.reducers';
import { freeSignatureReducer } from './free-signature/free-signature.reducer';
import { freeTermsReducers } from './free-terms/free-terms.reducer';
import { localStorageSync } from 'ngrx-store-localstorage';
import { promisoryNotesReducer } from '@literax/modules/promissory-notes/store/promissory-notes.reducer';
import { reducer } from '../modules/documents/store/document/document.reducers';
import { registrationReducers } from './registration/registration.reducers';
import { reportPromissoryNoteReducers } from './report/report-promissory-note.reducers';
import { reportReducers } from '@literax/store/report/report.reducers';
import { reviewersReducer } from './review-request/review-request.reducer';
import { rolsReducers } from './rol/rol.reducers';
import { signRequestReducers } from '../modules/documents/store/sign-request/sign-request.reducers';
import { signatureReducer } from '@literax/modules/documents/store/signature/signature.reducer';
import { statusReducers } from './status/status.reducers';
import { templatesFieldsReducer } from '@literax/store/template-fields/templates-fields.reducer';
import { templatesReducer } from '@literax/modules/templates/store/templates.reducer';
import { termsReducer } from './terms/terms.reducer';
import { titleNavbarReducers } from './title-navbar/title-navbar.reducer';
import { tokenRSAConfigurationsReducer } from '@literax/components/configurations/token-rsa/config/store/token-rsa.reducers';
import { userProfileReducer } from '@literax/components/platform/profiles/store/user-profiles.reducer';
import { validatorReducer } from '@literax/modules/validator/store/validator.reducer';
import { suretyValidatorReducer } from '@literax/modules/surety-validator/store/surety-validator.reducer';
import { workspaceReducer } from '@literax/modules/documents/store/workspace/workspace.reducers';
import {
  IPersonalizationConfigurations,
  initialPersonalizationConfigurationsState,
} from '@literax/components/configurations/personalization/config/store/personalization.state';
import { personalizationConfigurationsReducer } from '@literax/components/configurations/personalization/config/store/personalization.reducers';

export interface IAppState {
  router?: RouterReducerState;
  auth: AuthState;
  documents: IDocumentState;
  freeDocuments: IFreeDocumentState;
  registration: IRegistrationState;
  config: ConfigState;
  status: IStatusState;
  signRequests: ISignRequestState;
  signatures: ISignatureState;
  freeSignatures: IFreeSignatureState;
  attachments: IAttachmentState;
  users: ICLientUsersState;
  profiles: IProfilesState;
  titleNavbar: ITitleNavbarState;
  clients: IClientState;
  promissoryNotes: IPromissoryNotesState;
  templates: ITemplatesState;
  templatesFields: ITemplatesFieldsState;
  department: IDepartmentState;
  catalog: ICatalogState;
  rol: IRolState;
  reviewersWorkspace: IReviewRequestWorkspaceState;
  approversWorkspace: IApproverRequestWorkspaceState;
  apiConfigurations: IApiConfigurationsInterface;
  appearanceConfigurations: IAppearanceConfigurationsInterface;
  tokenRSAConfigurations: ITokenRSAConfigurations;
  personalizationConfigurations: IPersonalizationConfigurations;
  report: IReportState;
  company: ICompanyState;
  userProfiles: IUserProfiles;
  reportPromissoryNote: IPromissoryNoteReportState;
  terms: ITermsState;
  freeTerms: IFreeTermsState;
  core: ICoreState;
  // * reemplaza todo el state del workspace (document, currentDocument, currentAttachment, etc...)
  workspace: WorkspaceState;
  dashboard: IDashboardState;
  validator: IValidatorState;
  suretyValidator: ISuretyValidatorState;
  backButton: IBackButtonState;
}

export const initialAppState: IAppState = {
  auth: initialAuthState,
  documents: initialDocumentState,
  freeDocuments: initialFreeDocumentState,
  registration: initialRegistrationState,
  config: initialConfigState,
  status: initialStatusState,
  signRequests: initialSignRequestState,
  signatures: initialSignatureState,
  freeSignatures: initialFreeSignatureState,
  attachments: initialAttachmentState,
  users: initialClientUserState,
  profiles: initiaProfileslState,
  titleNavbar: initialTitleNavbarState,
  clients: initialClientState,
  promissoryNotes: initialPromissoryNotesState,
  templates: initialTemplatesState,
  templatesFields: initialTemplatesFieldsState,
  department: initialDepartmentState,
  catalog: initialCatalogState,
  rol: initialRolState,
  reviewersWorkspace: initialReviewRequestWorkspaceState,
  approversWorkspace: initialApproverRequestWorkspaceState,
  apiConfigurations: initialApiConfigurationsState,
  appearanceConfigurations: initialAppearanceConfigurationsState,
  tokenRSAConfigurations: initialTokenRSAConfigurationsState,
  report: initialReportState,
  company: initialCompanyState,
  userProfiles: initiaUserProfileslState,
  reportPromissoryNote: initialPromissoryNoteReportState,
  terms: initialTermsState,
  freeTerms: initialFreeTermsState,
  core: initialAplicationState,
  // * reemplaza todo el state del workspace (document, currentDocument, currentAttachment, etc...)
  workspace: initialWorkspaceState,
  dashboard: initialDashboardState,
  validator: initialValidatorState,
  suretyValidator: initialSuretyValidatorState,
  backButton: initialBackButtonState,
  personalizationConfigurations: initialPersonalizationConfigurationsState,
};

export function getInitialState(): IAppState {
  return initialAppState;
}

export const reducers: ActionReducerMap<IAppState> = {
  router: routerReducer,
  auth: authReducers,
  documents: reducer,
  freeDocuments: freeDocumentReducers,
  registration: registrationReducers,
  config: configReducers,
  status: statusReducers,
  signRequests: signRequestReducers,
  signatures: signatureReducer,
  freeSignatures: freeSignatureReducer,
  attachments: attachmentReducers,
  users: clientUserReducer,
  profiles: profileReducer,
  titleNavbar: titleNavbarReducers,
  clients: clientReducers,
  promissoryNotes: promisoryNotesReducer,
  templates: templatesReducer,
  templatesFields: templatesFieldsReducer,
  department: departmentReducers,
  catalog: catalogReducers,
  rol: rolsReducers,
  reviewersWorkspace: reviewersReducer,
  approversWorkspace: approversReducer,
  apiConfigurations: apiConfigurationsReducer,
  appearanceConfigurations: appearanceConfigurationsReducer,
  tokenRSAConfigurations: tokenRSAConfigurationsReducer,
  report: reportReducers,
  company: companyReducers,
  userProfiles: userProfileReducer,
  reportPromissoryNote: reportPromissoryNoteReducers,
  terms: termsReducer,
  freeTerms: freeTermsReducers,
  core: coreReducers,
  // * reemplaza todo el state del workspace (document, currentDocument, currentAttachment, etc...)
  workspace: workspaceReducer,
  dashboard: dashboardReducers,
  validator: validatorReducer,
  suretyValidator: suretyValidatorReducer,
  backButton: backButtonReducer,
  personalizationConfigurations: personalizationConfigurationsReducer,
};

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: ['auth', 'clients', 'config', 'titleNavbar'],
    rehydrate: true,
  })(reducer);
}

export const metaReducers: MetaReducer<IAppState>[] = !environment.production
  ? [localStorageSyncReducer]
  : [localStorageSyncReducer];
